import { Card, Group, Stack, Text } from '@mantine/core'

import { CopyWidgetButton } from './copy-widget-button'
import { DisplayAmount } from './DisplayAmount'

export const RevenueForecast = ({
  currency,
  pipelineStatusData,
  isLoading,
}: {
  pipelineStatusData:
    | {
        forecastARR: { value: number; tooltip: string }
        forecastLTV: { value: number; tooltip: string }
      }
    | undefined
  isLoading: boolean
  currency: string
}) => {
  const { targetRef, copyButton } = CopyWidgetButton({ title: 'Pipeline Status' })
  return (
    <Card
      shadow='sm'
      radius='md'
      withBorder
      c='#868e96'
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
      ref={targetRef}
    >
      <Group position='apart'>
        <Text fw={600}>REVENUE FORECAST:</Text>
        {copyButton}
      </Group>
      <Stack
        justify='space-between'
        style={{
          flex: 1,
          paddingTop: 10,
        }}
      >
        {[
          {
            label: 'ARR Forecast',
            value: pipelineStatusData?.forecastARR.value || 0,
            tooltip: pipelineStatusData?.forecastARR.tooltip,
          },
          {
            label: 'LTV Forecast',
            value: pipelineStatusData?.forecastLTV.value || 0,
            tooltip: pipelineStatusData?.forecastLTV.tooltip,
          },
        ].map(({ label, value, tooltip }) => (
          <DisplayAmount
            key={label}
            isLoading={isLoading}
            label={label}
            amount={value}
            currency={currency}
            tooltip={tooltip}
          />
        ))}
      </Stack>
    </Card>
  )
}
